import { forwardRef } from 'react';

import './Chip.scss';

export type ChipState = { label: string; checked: boolean };

export type ChipProps = ChipState & {
	onChange: (label: string) => void;
	tabIndex: number;
};

const Chip = forwardRef<HTMLDivElement, ChipProps>(
	({ label, checked, onChange, tabIndex }, ref) => {
		const onKeyDownOnChip = (event: React.KeyboardEvent<HTMLDivElement>) => {
			if (event.code === 'Enter' || event.code === 'Space') {
				changeChecked(event);
			}
		};

		const changeChecked = (
			event:
				| React.MouseEvent<HTMLDivElement, MouseEvent>
				| React.KeyboardEvent<HTMLDivElement>
		) => {
			event.preventDefault();
			event.stopPropagation();
			onChange(label);
		};

		return (
			<div
				className="blk-ac-chip"
				role="checkbox"
				aria-label={label}
				aria-checked={checked}
				tabIndex={tabIndex}
				onClick={changeChecked}
				onKeyDown={onKeyDownOnChip}
				ref={ref}
			>
				{label}
			</div>
		);
	}
);

Chip.displayName = 'Chip';

export default Chip;
